import styled from '@emotion/styled';
import { InputBase, Paper } from '@mui/material';
import { shouldForwardProps } from '../../utils';

type SearchProps = {
    isElevated?: boolean;
    isFocused: boolean;
};

const SearchWrapper = styled(
    Paper,
    shouldForwardProps
)<SearchProps>(({ isElevated, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    maxWidth: '600px',
    minWidth: '250px',
    height: '56px',
    padding: theme.spacing(0.5),
    backgroundColor: theme.colors.background,
    boxShadow: isElevated
        ? '0px 1px 3px 0px rgba(0, 0, 0, 0.30), 0px 4px 8px 3px rgba(0, 0, 0, 0.15)'
        : 'none'
}));

const StyledInputBase = styled(InputBase)`
    width: 100%;
    height: 24px;
    color: inherit;
`;

export { SearchWrapper, StyledInputBase };
